import { Inject } from '@odinjs/odin';
import { ContextType, Value } from '@philips-internal/oswald-ui-core';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/history-service';
import { foundationContext, User } from '@philips-internal/oswald-ui-foundation';

interface DataContext {
  get(key: string): Value;
  set(data: {
    [key: string]: Value
  }): void;
}

export default class BaseController {

  @Inject(ContextType.DATA)
  context!: DataContext;

  protected getContextId(param: string = 'id'): string {
    return this.context.get(param) as string;
  }

  protected getPathId(param: string = 'id'): string {
    return HistoryService.getCurrentRouteParams()[param] as string;
  }

  protected getEstablishmentId(): number {
    const establishmentId = foundationContext.getEstablishment()?.id;
    if (establishmentId) {
      return Number(establishmentId);
    }
    return 0;
  }

  protected getLoggedUser(): User {
    const loggedUser = foundationContext.getUser();
    if (!loggedUser) {
      throw Error('Logged user not found.');
    }
    return loggedUser;
  }

  protected getLoggedUserId(): string {
    const loggedUser = this.getLoggedUser();
    return loggedUser.id;
  }

  protected hasPermission(permissionCode: string): boolean {
    const modules = foundationContext.getAvailableModules();
    if (modules) {
      return modules.some(m => m.id === permissionCode);
    }
    return false;
  }

  protected getContextData(key: string): Value {
    return this.context.get(key);
  }

}
